/* es5-ext/object/assign/index */ function _(require, module, exports) {
    module.exports = require(340) /* ./is-implemented */()
        ? Object.assign
        : require(341) /* ./shim */;
}
